import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import PresenceSection from "../components/PresenceSection";
import ProductsSection from "../components/ProductsSection";
import RecognitionsSection from "../components/RecognitionsSection";
import ContactSection from "../components/ContactSection";
import SeoContentSection from "../components/SeoContentSection";
import Footer from "../components/Footer";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const sectionId = location.hash.replace("#", "");
    const element = document.getElementById(sectionId);
    if (element) {
      requestAnimationFrame(() => {
        element.scrollIntoView({ behavior: "smooth" });
      });
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-[#1a0f08]">
      <Header />
      <main id="main-content">
        <HeroSection />
        <AboutSection />
        <PresenceSection />
        <ProductsSection />
        <RecognitionsSection />
        {/* <SeoContentSection /> */}
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
